import { Directive, Injectable } from '@angular/core';
import { GraphsApiService } from './graphs-api.service';
import { lastValueFrom } from 'rxjs';
import { BarGraphChannel, DefaultGraphStyle } from '@models/graphs';
import { Graph } from 'ops/common/models/graphs';

@Directive()
@Injectable()
export class GraphsService {
    alarmStateMap = new Map();

    constructor(private api: GraphsApiService) {}

    async getAll(): Promise<Graph[]> {
        return lastValueFrom(this.api.getAll());
    }

    generateTitleArr(channels: BarGraphChannel[]) {
        let titles = [];
        for (let i = 0; i < channels.length; i++) {
            titles[i] = {
                value: channels[i].title,
                textStyle: {
                    color: DefaultGraphStyle.blueColor,
                    fontSize: DefaultGraphStyle.fontSize,
                },
            };
        }

        return titles;
    }

    generateValueArr(channels: BarGraphChannel[]) {
        let values = [];
        for (let i = 0; i < channels.length; i++) {
            values[i] = {
                value: channels[i].value,
                textStyle: {
                    color: DefaultGraphStyle.whiteColor,
                    fontSize: DefaultGraphStyle.fontSize,
                    fontWeight: 'bolder',
                },
            };
        }

        return values;
    }

    getTootipBlueText(name) {
        return `<div style="color:${DefaultGraphStyle.blueColor};padding: 2px;">${name}</div>`;
    }

    getTootipBlueTextBold(name) {
        return ` <div style="color:${DefaultGraphStyle.blueColor};padding: 2px; font-weight: bold;">${name}</div>`;
    }

    getTootipWhiteText(name) {
        return `<div style="color:${DefaultGraphStyle.whiteColor};padding: 2px; font-weight: bold;">${name}</div>`;
    }

    getTootipSubname(name, value) {
        return `<div style="display:flex; gap:8px; align-items: center"><span style="color:${DefaultGraphStyle.whiteColor}">${name}</span>${value}</div>`;
    }
}
